import { themeConstants } from '@paywithextend/components'
import { spacing } from 'ext-ui/style/spacing'
import AgentChat from 'src/agent/components/AgentChat/AgentChat'
import { AgentPlacement } from 'src/agent/redux/agent.reducer'
import styled, { css } from 'styled-components'

export const AgentFixedContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 12;
`

export const AgentWindowWrapper = styled.div`
  width: 600px;
  min-height: 150px;
`

export const AgentWindow = styled.div<{ placement?: AgentPlacement }>`
  width: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background:
    linear-gradient(0deg, rgba(250, 250, 250, 0.85), rgba(250, 250, 250, 0.85)),
    rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  pointer-events: auto;
  cursor: move;
  user-select: none;
  position: absolute;
  ${(props) =>
    props.placement === 'top'
      ? css`
          bottom: 0;
        `
      : css`
          top: 0;
        `}
`

// TODO: AGENT replace with ext-ui icon button when available
export const CloseButton = styled.div`
  display: flex;
  position: relative;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;

  svg {
    transition: stroke 0.2s ease;
  }

  svg path {
    stroke: ${themeConstants.colors.font_primary};
    transition: stroke-width 0.2s ease;
  }

  &:hover {
    svg path {
      stroke: ${themeConstants.colors.cta};
    }
  }
`

export const AgentChatWindow = styled(AgentChat)`
  max-height: 75vh;
  padding: ${spacing(2)};
  cursor: auto;
  user-select: text;
`
